import dayjs from "dayjs";
import { generateBins, getBinDefinitons, type BobEvent, type Bin } from "../../../shared/sharedService/helpers.ts";

/** The API already scopes devices to the user; every returned open maintenance belongs in the list. */
export function serviceOverviewBins<Event extends BobEvent>(events: Event[], role: "site" | "service") {
  const definitions = getBinDefinitons(role);
  const overdue = definitions[0].rule;
  definitions[0].rule = (event) => overdue(event) || (
    (event.category === "testing" || event.category === "meterReading")
    && !event.completedAt && !!event.dueAt && dayjs(event.dueAt).isBefore(dayjs(), "day")
  );
  return generateBins(events, definitions, true) as (Omit<Bin, "events"> & { events: Event[] })[];
}
